<template>
  <Layout>
    <McTable
      :fields="fields"
      :apiClient="apiClient"
      :customHandlers="{
        handleClickRow,
      }"
      withCard
      searchable
      stickyHeader
      hasTooltip
    >
      <template #before-table="{ isSelected, showDeleteModal }">
        <PageHeader
          :title="title"
          :subTitle="subTitle"
          :items="breadcrumbItems"
          hasBreadcrumb
          hasBackButton
        >
          <template #afterTitle>
            <b-button-group class="d-flex gap-2">
              <McButton
                v-if="isSelected"
                variant="secondary-red"
                :text="$t('global.delete')"
                icon="icon-outline_trash"
                @click="showDeleteModal"
              />
              <McButton
                variant="primary"
                :text="$t('global.addField')"
                icon="icon-fill_plus"
                @click="handleAdd"
              />
            </b-button-group>
          </template>
        </PageHeader>
      </template>
      <template #thead-top="">
        <b-tr>
          <b-th colspan="3" />
          <b-th colspan="5" class="text-center">
            {{ $t('setting.list.webhook.totalAlert') }}
          </b-th>
        </b-tr>
      </template>
      <template #cell(general)="data">
        <div>
          {{ totalFleet(data.item, 'General') }}
        </div>
      </template>
      <template #cell(dms)="data">
        <div>
          {{ totalFleet(data.item, 'DMS') }}
        </div>
      </template>
      <template #cell(driverBehavior)="data">
        <div>
          {{ totalFleet(data.item, 'Driver Behavior') }}
        </div>
      </template>
      <template #cell(adas)="data">
        <div>
          {{ totalFleet(data.item, 'ADAS') }}
        </div>
      </template>
      <template #cell(dataUpdate)="data">
        <div>
          {{ totalFleet(data.item, 'Data Update') }}
        </div>
      </template>
      <template #emptyState>
        <div class="empty-table-container">
          <McEmptyState
            :title="empyStateProps.title"
            :desc="empyStateProps.desc"
            @buttonPrimaryAction="handleAdd"
          />
        </div>
      </template>
    </McTable>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2.vue'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'
import McTable from '@/components/McTable'
import McEmptyState from '@/components/McEmptyState'
import getFields from './lib/fields'
import * as webhookAPI from '@/services/rest-api-webhook/lib/webhook/webhook'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McTable,
    McEmptyState,
  },
  computed: {
    title() {
      return this.$t('setting.homePage.webhook')
    },
    subTitle() {
      return this.$t('setting.homePage.textWebhook')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.deliverySetting.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.webhook'),
        },
      ]
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    apiClient() {
      return {
        get: webhookAPI.get,
        delete: webhookAPI.remove,
      }
    },
    fields() {
      return getFields(this)
    },
    empyStateProps() {
      return {
        title: this.$t('setting.list.webhook.empty'),
        desc: this.$t('setting.reasonCancel.add'),
      }
    },
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: 'Create Webhook' })
    },
    handleClickRow(item) {
      this.$router.push({ name: 'Detail Webhook', params: { id: item.id } })
    },
    totalFleet(item, groupName) {
      const group = item.group.find((group) => group.name === groupName)
      if (group && group.event_vehicle) {
        return group.event_vehicle.reduce((total, event) => total + event.vehicle_ids.length, 0)
      }
      return 0
    },
  },
}
</script>
